import "../App.css";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <Container className="footer" fluid>
      <Row className="py-3">
        <Col xs={12} md={8} className="left-area d-flex align-items-center gap-5 ps-4 mb-4 mb-md-0">
          
          <Image src="/musc_white.png" alt="MUSC Logo" style={{ maxHeight: "125px" }} fluid />
          
          <div style={{ borderLeft: "2px solid white", height: "100px" }}></div>
          
          <div>
            <div className="mb-3" style={{ fontSize: "0.93rem", fontWeight: "500" }}>
              National Crime Victims<br />Research & Treatment Center
            </div>
            <div className="copyright">© {new Date().getFullYear()} Medical University of South Carolina</div>
          </div>

        </Col>
        <Col xs={12} md={4} className="right-area d-flex flex-column justify-content-center align-items-md-end pe-0 pe-md-4">
          <div className="links text-center text-md-end">
            <div>
              <Link to="/about">About</Link>
            </div>
            <div>
              <Link to="/ceustatement">CEU Statement</Link>
            </div>
            <div>
              <Link to="/privacypolicy">Privacy Policy</Link>
            </div>
            <div>
              <Link to="/termsandconditions">Terms and Conditions</Link>
            </div>
          </div>
        </Col>

      </Row>
    </Container>
  );
}

export default Footer;
